import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import { AuthDataProvider } from 'src/components/authProvider';
import { ScreenConfiguration } from 'src/components/screenConfiguration';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { lang } from 'src/utils';

import { LocationCalendarHeaderProps } from './LocationCalendarHeader.interface';
import {
  Container,
  SubHeader,
  SubHeaderText,
} from './LocationCalendarHeader.styled';

export const LocationCalendarHeader = (props: LocationCalendarHeaderProps) => {
  const { userRole } = useContext(AuthDataProvider);

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Grid container rowSpacing={2} columnSpacing={6}>
            <Grid item>
              <SubHeader>{lang.screenConfiguration}</SubHeader>
              {props.selectedLocationGroup?.channel_name && (
                <ScreenConfiguration
                  channelName={props.selectedLocationGroup?.channel_name}
                  scale={0.03}
                />
              )}
            </Grid>
            {userRole !== AuthClassification.OWNER_OPERATOR && (
              <Grid item>
                <SubHeader>{lang.locationGroup}</SubHeader>
                <SubHeaderText>
                  {props.selectedLocationGroup?.name}
                </SubHeaderText>
              </Grid>
            )}
            <Grid item>
              <SubHeader>{lang.channelType}</SubHeader>
              <SubHeaderText>
                {props.selectedLocationGroup?.layoutType?.name}
              </SubHeaderText>
            </Grid>
          </Grid>
        </Grid>

        {/* NOTE : Please do not delete this. Code to be enabled after OO have sufficent editing priveledges.*/}

        {/* {userRole === AuthClassification.OWNER_OPERATOR && (
          <>
            {!props.scheduleDaypartsAvailable && (
              <Grid item xs={12} md={5}>
                <BoxContainer>
                  <AlertContainer>
                    <InfoBox visible>
                      {lang.alertMessages.OOeditSchedules}
                    </InfoBox>
                  </AlertContainer>
                </BoxContainer>
              </Grid>
            )}
          </>
        )} */}
      </Grid>
    </Container>
  );
};
